import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PageHeader, EmptyState } from "@/components/ui-bits";
import api from "@/lib/api";

export default function StudentResults() {
  const [results, setResults] = useState([]);
  useEffect(() => { api.get("/results").then(r => setResults(r.data)); }, []);

  return (
    <div>
      <PageHeader title="Results" subtitle="Your assessment history and scores." />
      {results.length === 0 ? <EmptyState title="No results yet" hint="Take an assessment to see your scores here." /> : (
        <div className="bg-white border border-slate-200 rounded-xl overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-slate-600 text-left">
              <tr><th className="px-6 py-3 font-medium">Assessment</th><th className="px-6 py-3 font-medium">Score</th><th className="px-6 py-3 font-medium">%</th><th className="px-6 py-3 font-medium">Status</th><th className="px-6 py-3 font-medium">Date</th><th className="px-6 py-3 font-medium text-right">View</th></tr>
            </thead>
            <tbody>
              {results.map(r => (
                <tr key={r.id} className="border-t border-slate-100">
                  <td className="px-6 py-3 font-medium text-slate-900">{r.assessment_title}</td>
                  <td className="px-6 py-3 text-slate-700">{r.score}/{r.total}</td>
                  <td className="px-6 py-3 font-medium">{r.percentage}%</td>
                  <td className="px-6 py-3">
                    <span className={`text-xs font-medium px-2 py-1 rounded-full ${r.status==='passed'?'bg-emerald-50 text-emerald-700':'bg-red-50 text-red-700'}`}>{r.status}</span>
                  </td>
                  <td className="px-6 py-3 text-slate-500">{r.submitted_at?.slice(0,10)}</td>
                  <td className="px-6 py-3 text-right">
                    <Link to={`/student/result/${r.id}`} data-testid={`result-view-${r.id}`} className="text-blue-600 font-medium hover:underline">Open</Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
